import { Link } from "react-router-dom";

const ApiSettings = () => {
  return (
    <div className="mt-5">
      <div className="max-w-[720px]">
        {/* Citations API */}
        <div className="border border-[#EAECF0] rounded-lg p-5">
          <h5 className="text-sm text-[#344054] font-interSemiBold pb-0.5">
            Citations API
          </h5>
          <p className="text-sm text-[#475467]">
            Authenticate requests to the Citations API using the{" "}
            <span className="font-interMedium text-[#101828]">X-API-Key</span>{" "}
            request header. See the reference for endpoints, request and response
            formats, and error codes.{" "}
            <Link
              to="/api-reference"
              className="text-[#1751D0] hover:underline font-interMedium"
            >
              View API Reference
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ApiSettings;
